import React, { useState } from 'react';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';

import LayoutsList from './LayoutsList';
import SamplesList from './SamplesList';

type Props = {
  close: () => void;
};
export default function TemplateBody({ close }: Props) {
  const [currentTab, setCurrentTab] = useState<'LAYOUTS' | 'SAMPLES'>('SAMPLES');
  const handleChange = (_: unknown, value: unknown) => {
    const v = value === 'LAYOUTS' ? 'LAYOUTS' : 'SAMPLES';
    setCurrentTab(v);
  };
  return (
    <TabContext value={currentTab}>
      <TabList
        onChange={handleChange}
        aria-label="lab API tabs example"
        sx={{ borderBottom: '1px solid', borderBottomColor: 'divider' }}
      >
        <Tab label="From a sample" value="SAMPLES" />
        <Tab label="From a layout" value="LAYOUTS" />
      </TabList>
      <TabPanel value="SAMPLES" sx={{ px: 0 }}>
        <SamplesList close={close} />
      </TabPanel>
      <TabPanel value="LAYOUTS" sx={{ px: 0 }}>
        <LayoutsList close={close} />
      </TabPanel>
    </TabContext>
  );
}
